import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { publicImageUrl } from '../utils/publicAsset';

const img = (file) => publicImageUrl(file);

const FAVICON_BY_SECTION = {
  landing: img('updatedlogo.png'),
  logistics: img('updatedlogo.png'),
  marketing: img('marketinglogo.png'),
};

const TITLE_BY_SECTION = {
  landing: '1st Luxury',
  logistics: '1st Luxury Logistics',
  marketing: '1st Luxury Marketing',
};

const getSection = (pathname) => {
  if (pathname === '/') return 'landing';
  if (pathname.startsWith('/marketing')) return 'marketing';
  return 'logistics';
};

const setLinkIcon = (href) => {
  const selectors = ["link[rel='icon']", "link[rel='shortcut icon']", "link[rel='apple-touch-icon']"];
  selectors.forEach((selector) => {
    let link = document.querySelector(selector);
    if (!link) {
      link = document.createElement('link');
      link.rel = selector.includes('apple') ? 'apple-touch-icon' : 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = href;
  });
};

const SiteFavicon = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const section = getSection(pathname);
    setLinkIcon(FAVICON_BY_SECTION[section]);
    document.title = TITLE_BY_SECTION[section];
  }, [pathname]);

  return null;
};

export default SiteFavicon;
